import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('GlobalWindow', {
  providedIn: 'root',
  factory: () => window
});

export const ENV_JSON = new InjectionToken<JSON>('GlobalJSON', {
  providedIn: 'root',
  factory: () => JSON
});
